// extracted by mini-css-extract-plugin
export default {"container":"Button_container__aKtNe","Main":"Button_Main__ZMnB8","Bordered":"Button_Bordered__KH7vd"};